export default __webpack_public_path__ + "static/5-d5b60b2ddb71d517a15e149dcea52e72.webp";